import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import * as configSelectors from '@elab/core/store/config/selectors';
import { loadAsset } from '@elab/core/utils/helpers';

const CONTAINER_ID = 'iframe-container';
class PSPiframe extends SimpleLitElement {
    static get properties() {
        return {
            checkoutId: { type: String, attribute: 'checkout-id' },
            notLive: { type: Boolean, attribute: 'not-live' },
            stylesConfig: { type: Object, attribute: false },
        };
    }

    constructor() {
        super();
        this.stylesConfig = null;
        this.notLive = false;
        this.checkoutId = '';
    }

    options() {
        return { live: !this.notLive, styles: this.stylesConfig };
    }

    async initPaymentIframe() {
        await loadAsset('acehub');
        const { acehub } = window.e2_assets;
        const checkout = new acehub(this.checkoutId, CONTAINER_ID, this.options());
        checkout.render();
    }

    updated() {
        if (this.stylesConfig && !this.__initialized) {
            this.initPaymentIframe();
            this.__initialized = true;
        }
    }
}

const mapStateToProps = state => ({
    stylesConfig: configSelectors.getPspStylesConfig(state),
});

export default () => customElements.define('e2-psp-iframe', connect(mapStateToProps)(PSPiframe));
